import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { SampleIssue } from "@/components/SampleIssue";
import { Founder } from "@/components/Founder";
import { Mission } from "@/components/Mission";
import { Process } from "@/components/Process";
import { Features } from "@/components/Features";
import { Pricing } from "@/components/Pricing";
import { Footer } from "@/components/Footer";
import { LeadModal } from "@/components/LeadModal";
import { PrivacyPage, CancellationPage } from "@/components/LegalPages";
import { PAPER_TEXTURE } from "@/constants/site";

const getView = () => {
  const h = window.location.hash;
  if (h === "#/privacy") return "privacy";
  if (h === "#/cancellation") return "cancellation";
  return "home";
};

export default function App() {
  const [leadOpen, setLeadOpen] = useState(false);
  const [view, setView] = useState(getView);
  const openLead = () => setLeadOpen(true);

  useEffect(() => {
    const onHash = () => setView(getView());
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  useEffect(() => {
    if (view !== "home") window.scrollTo(0, 0);
  }, [view]);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  if (view === "privacy") return <PrivacyPage />;
  if (view === "cancellation") return <CancellationPage />;

  return (
    <div className="min-h-screen overflow-x-clip bg-cream font-sans text-walnut antialiased">
      <img
        src={PAPER_TEXTURE}
        alt=""
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 z-40 h-full w-full object-cover opacity-10 mix-blend-multiply"
      />
      <Header openLead={openLead} />
      <main>
        <Hero openLead={openLead} />
        <SampleIssue openLead={openLead} />
        <Founder />
        <Mission />
        <Process />
        <Features />
        <Pricing openLead={openLead} />
      </main>
      <Footer openLead={openLead} />
      <LeadModal open={leadOpen} onClose={() => setLeadOpen(false)} />
    </div>
  );
}
